import axios from 'axios'

const media = {
    state: {
        media: null
    },
    mutations: {
        UPDATE_MEDIA(state, payload) {
            state.media = payload
        },
    },
    actions: {
        uploadMedia: async ({
            commit
        }, {
            body
        }) => {

            const config = {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                    'Content-Type': 'multipart/form-data'
                }
            }

            try {
                const payload = await axios.post(`${process.env.VUE_APP_API}/media/upload`, body, config)

                return {
                    status: 200,
                    data: payload.data
                }

            } catch (e) {
                console.log(e)
                return {
                    status: 500,
                    error: e
                }
            }
        },
        fetchMedia: async ({
            commit
        }) => {
            const config = {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                }
            }

            try {
                const payload = await axios.get(`${process.env.VUE_APP_API}/media/all`, config)

                const media = payload.data.map(el => {
                    el.edit = false
                    el.src = `${process.env.VUE_APP_API}/img/${el.name}`
                    return el
                })

                commit('UPDATE_MEDIA', media)

                return {
                    status: 200,
                    message: 'Success',
                    data: media
                }

            } catch (e) {
                console.log(e)
                return {
                    status: 500,
                    message: 'Error',
                    error: e
                }
            }
        },
        editMedia: async ({
            commit
        }, media) => {
            const config = {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                }
            }

            try {
                await axios.post(`${process.env.VUE_APP_API}/media/edit`, media, config)

                return {
                    status: 200,
                    message: 'Success',
                }

            } catch (e) {
                console.log(e)
                return {
                    status: 500,
                    message: 'Error',
                    error: e
                }
            }
        },
        deleteMedia: async ({
            commit
        }, media) => {
            const config = {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                }
            }

            try {
                await axios.post(`${process.env.VUE_APP_API}/media/delete`, media, config)

                return {
                    status: 200,
                    message: 'Success',
                }

            } catch (e) {
                console.log(e)
                return {
                    status: 500,
                    message: 'Error',
                    error: e
                }
            }
        }
    },
    getters: {
        media: state => state.media
    }
}

export default media